// extracted by mini-css-extract-plugin
export default {"text":"ConfirmDialog_text__D8sGw","secondary":"ConfirmDialog_secondary__5xHXM","danger":"ConfirmDialog_danger__To0XH"};